import { Component, EventEmitter, OnInit, Output, Input, OnDestroy } from '@angular/core';

import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { HelperService, HTTPService, CalculationService, DataService, FormatService } from 'app/services';
import { findIndex, debounce, find } from 'lodash';
import { config } from 'app/constants';

import { Subscription } from 'rxjs';
@Component({
  selector: 'app-inventory-tire-lookup',
  templateUrl: './inventory-tire-lookup.component.html',
  styleUrls: ['./inventory-tire-lookup.component.scss'],
  providers: [DialogService],
})
export class InventoryTireLookupComponent implements OnInit, OnDestroy {
  @Input() isRunTireStorageFlow: boolean = false;
  @Input() isOpenFromRO: boolean = false;
  @Input() isOpenFromQuickTireLookup: boolean = false;
  @Input() tires: any[] = [];
  @Input() isTabActive: boolean = false;
  @Input() isEmptySizes: boolean = false;
  @Input() isCartVisible: boolean = false;
  @Input() isTireSizesLoading: boolean = false;
  @Input() selectedQty: number = 4;
  @Input() globalCartItemList: any = [];
  @Input() globalCartCount: number = 0;
  @Input() defaultServiceTotal: number = 0;
  @Input() hideCost: boolean = false;
  @Input() taxAmtOnAdonService: number = 0;
  @Input('selectedTab')
  set tabSelectionAction(selectedTab: number) {
    if (selectedTab === 0) {
      if (!this.isQTQAddOnEnable) {
        this.getTireAttr();
      } else {
        if (this.isTabActive) {
          this.pageNumber = 1;
          if (this.tires && !this.tires?.length) {
            this.getTireSizesAndStock();
          }
        }
      }
    }
  }
  @Input('selectedTireSize')
  set fetchTires(selectedTireSize: any) {
    if (this.isQTQAddOnEnable) {
      if (selectedTireSize && Object.keys(selectedTireSize)?.length > 0) {
        this.tireSize = selectedTireSize.tireSize;
        this.tireWidth = selectedTireSize.tireWidth;
        this.tireProfile = selectedTireSize.tireProfile;
        this.pageNumber = 1;

        if (this.isTabActive) {
          this.getTireSizesAndStock();
        }
      }
    } else {
      if (this.isTabActive) {
        this.tireSize = selectedTireSize;
        this.pageNumber = 1;

        this.getTireSizesAndStock();
      }
    }
  }
  @Input('emptyCart')
  set emptyCart(empty: boolean) {
    if (empty) {
      this.removeCartItems();
    }
  }
  @Input('setSelectedTax')
  set setSelectedTax(tax: any) {
    this.selectedTax = tax;
    if (this.isQTQAddOnEnable) {
      if (this.tires?.length) {
        this.handleTaxSelect();
      }
    }
  }

  @Output() appHandleSelectTire = new EventEmitter();
  @Output() appSetTireSizeAttr = new EventEmitter();
  @Output() appHandleAlTireValidation = new EventEmitter();
  @Output() updateSelectedItemCount = new EventEmitter();
  @Output() appOnAddCustomerAndVehicle = new EventEmitter();
  @Output() appOnSetGlobalCart = new EventEmitter();

  isLoading: boolean = false;
  orderId: string = '';
  cartId: string = '';
  vehicle: any = {};
  services: any[] = [];
  tireWidths: any[] = [];
  tireSizes: any[] = [];
  tireProfiles: any[] = [];
  selectedAttr = {
    tireWidth: { _id: null },
    tireProfile: { _id: null },
    tireSize: { _id: null },
  };
  selectedTire: any = {};
  searchQuery: string = '';
  isSelectedRecomended: boolean = true;
  isTireSelected: boolean = false;
  pageSize: number = config.pageSize;
  pageNumber: number = 1;
  isTireFetching: boolean = false;
  isSubmitting: boolean = false;
  tireSize: string = '';
  tireWidth: string = '';
  tireProfile: string = '';
  totalRecords: number = 0;
  cartDetails = {};
  cartSummary = {
    total: 0,
    shippingCost: 0,
    grand: 0,
    count: 0,
    totalPrice: 0,
    grandPrice: 0,
    totalTaxAmount: 0,
    totalFetValue: 0,
  };
  shippingLoader = {};
  cartitemList = [];
  selectedTireId = {};
  warehouseShippings = {};
  isQTQAddOnEnable: boolean = this.dataService.isQTQAddOnEnable;
  dataServiceSubscription: Subscription;
  selectedTax: any = {};
  isPassThroughTaxEnable: boolean = this.dataService.isPassThroughTaxEnable;
  filterOptionStylecss: any = {
    width: '120px',
    'font-weight': '600',
    padding: '0 3px',
  };
  filterOptions = {
    multipleGenericFilters: true,
  };
  multipleGenericFiltersKeys: any = ['availability', 'orderBy'];
  multipleGenericFiltersObject: any = {
    availability: {
      data: [
        { _id: 'all', name: 'All' },
        { _id: 'local', name: 'Local only' },
      ],
      filterOptions: {
        iconClass: 'fa-check',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Availability',
        multipleSelectText: 'Multiple selected',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: true,
      selected: [{ _id: 'all', name: 'All' }],
    },
    orderBy: {
      data: [
        { _id: 'low_stock', name: 'Stock: low to high' },
        { _id: 'high_stock', name: 'Stock: high to low' },
      ],
      filterOptions: {
        iconClass: 'fa-sort-alt',
        nameField: 'name',
        valueField: '_id',
        selectAllText: 'Sort by',
        multipleSelectText: 'Multiple selected',
        styleCss: this.filterOptionStylecss,
        filterOverlayStyle: {
          width: '173px',
        },
        isSingleSelect: true,
      },
      filterApplied: false,
      selected: [],
    },
  };
  filter: any = {};

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
    private calculationService: CalculationService,
    private dataService: DataService,
    private formatService: FormatService
  ) {}

  ngOnInit() {
    const { vehicle, services, orderId, isOpenFromQuickTireLookup } = this.dynamicDialogConfig.data;
    const { isMultiLocationEnabled } = this.helperService.getCompany();

    this.orderId = orderId;
    this.services = services;
    this.vehicle = vehicle;
    this.isOpenFromQuickTireLookup = isOpenFromQuickTireLookup;
    if (this.isOpenFromQuickTireLookup) {
      this.isTireSizesLoading = false;
    }

    if (this.isQTQAddOnEnable) {
      this.setDataListners();
    }

    if (isMultiLocationEnabled) {
      this.multipleGenericFiltersObject.availability.data.push({ _id: 'local_or_other', name: 'Local or other only' });
      this.multipleGenericFiltersObject.availability.selected = [{ _id: 'local_or_other', name: 'Local or other only' }];
      this.filter.availability = 'local_or_other';
    } else {
      this.multipleGenericFiltersObject.availability.selected = [{ _id: 'local', name: 'Local only' }];
      this.filter.availability = 'local';
    }
  }

  setDataListners() {
    this.dataServiceSubscription = this.dataService.getData().subscribe((obj) => {
      if (obj.data.key === 'handleTireSelect' && obj.data?.data?.source === 'autoleap') {
        this.handleTireSelect(obj.data?.data?.tireId, obj.data?.data?.tire, obj.data.key);
      }
      if (obj.data.key === 'handleTireSelectQTQ' && obj.data?.data?.source === 'autoleap') {
        this.handleTireSelect(obj.data?.data?.tireId, obj.data?.data?.tire, 'handleTireSelectQTQ');
      }
      if (obj.data.key === 'handleCountChange' && obj.data?.data?.source === 'autoleap') {
        this.handleCountChange(obj.data?.data?.tireId, obj.data?.data?.count, false, obj.data.key);
      }
    });
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  getTireSizesAndStock = debounce((fetchSizes: boolean = false, page: number = 1) => {
    if (!this.isQTQAddOnEnable) {
      if (!this.isEmptySizes && !this.tireSize) return;
    } else {
      if (!this.isEmptySizes && !this.tireSize && !this.tireWidth && !this.tireProfile) return;
    }

    const options: any = { fetchSizes };

    if (!fetchSizes) {
      const { tireWidth, tireProfile, tireSize } = this.selectedAttr;

      if (tireWidth._id && tireProfile._id && tireSize._id) {
        options.tireWidth = tireWidth._id;
        options.tireProfile = tireProfile._id;
        options.tireSize = tireSize._id;

        options.sizes = [`${options.tireWidth}${options.tireProfile}${options.tireSize}`];
      } else {
        options.sizes = [this.tireSize];
      }
    }

    if (this.isQTQAddOnEnable) {
      options.fetchQTQData = true;
      options.tireWidth = this.tireWidth;
      options.tireProfile = this.tireProfile;
      options.tireSize = this.tireSize;
      options.limit = config.pageSize;
      options.page = page;
    } else {
      options.fetchQTQData = false;
      options.limit = config.pageSize;
      options.page = page;
    }

    if (this.filter.availability) {
      options.availability = this.filter.availability;
    }

    if (this.filter.orderBy) {
      options.orderBy = this.filter.orderBy;
    }

    this.isLoading = true;
    this.httpService
      .getVehicleRecomendedParts(this.vehicle, options)
      .then(
        ({ tires }: any) => {
          if (tires.metaData) {
            this.totalRecords = tires.metaData.totalRecords;
          }
          if (tires.records?.length) {
            tires.records.forEach((tire: any) => {
              const { localAvailable, otherAvailable, stockCountAvailable } = this.formatService.getLocalAndOtherForALInvCount(tire);
              if (tire?.locations?.length) {
                let [location] = tire.locations;
                if (this.helperService.getCompany().isMultiLocationEnabled) {
                  const obj = find(tire.locations, { warehouseId: this.dataService.warehouse?.warehouseId, stocked: true });
                  if (obj) {
                    location = obj;
                  }
                }
                if (location) {
                  tire.warehouse = location;
                }

                if (tire?.count > tire?.countAvailable) {
                  tire.count = tire?.countAvailable;
                }
              }

              tire.cost = this.formatService.setDynamicCostAndPrice(tire, 'cost');
              tire.price = this.formatService.setDynamicCostAndPrice(tire, 'price');
              tire.displayTitle = tire?.title;

              if (stockCountAvailable) {
                tire.countAvailable = stockCountAvailable;
              }
              tire.fetValue = tire?.fetValue || 0;
              tire.localAvailable = localAvailable;
              tire.otherAvailable = otherAvailable;
              tire.localFetValue = tire.fetValue;
            });
          }

          if (this.tires?.length && tires.records?.length && page > 1) {
            this.tires = [...this.tires, ...tires.records];
          } else {
            this.tires = (tires && tires.records) || [];
          }
        },
        (err: any) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isLoading = false;
      });
  }, 1000);

  getTireAttr(type: string = 'tireWidths') {
    const options: any = {};

    if (this.selectedAttr.tireWidth && this.selectedAttr.tireWidth._id) {
      options.tireWidth = this.selectedAttr.tireWidth._id;
    }

    if (this.selectedAttr.tireProfile && this.selectedAttr.tireProfile._id) {
      options.tireProfile = this.selectedAttr.tireProfile._id;
    }

    this.httpService.getTireAttr(options).then(
      (attr) => {
        if (type === 'tireWidths') {
          this.tireWidths = attr.tireWidths;
        } else if (type === 'tireSizes') {
          this.tireSizes = attr.tireSizes;
        } else if (type === 'tireProfiles') {
          this.tireProfiles = attr.tireProfiles;
        }

        if (this.isTabActive) {
          this.appSetTireSizeAttr.emit({ widths: this.tireWidths, profiles: this.tireProfiles, sizes: this.tireSizes });
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleSizeSelect(key: string, value: any) {
    if (key === 'tireWidth') {
      if (value !== this.selectedAttr.tireWidth._id) {
        this.selectedAttr.tireWidth = value;

        this.selectedAttr.tireProfile = null;
        this.selectedAttr.tireSize = null;

        this.tireProfiles = [];
        this.tireSizes = [];

        this.getTireAttr('tireProfiles');
      }
    } else if (key === 'tireProfile') {
      this.selectedAttr.tireProfile = value;

      this.selectedAttr.tireSize = null;
      this.tireSizes = [];

      this.getTireAttr('tireSizes');
    } else if (key === 'tireSize') {
      this.selectedAttr.tireSize = value;

      // Remove recommended size search when using recommended sizes
      this.getTireSizesAndStock();
    }
  }

  handleTireSelect(tireId: string, tire: any, callingFrom?: string) {
    if (tire) {
      this.selectedTire[tireId] = tire;
    } else {
      delete this.selectedTire[tireId];
      this.appHandleSelectTire.emit(this.helperService.deepCopy(this.selectedTire));
    }

    if (Object.keys(this.selectedTire).length) {
      this.isTireSelected = true;
    } else {
      this.isTireSelected = false;
    }

    if (this.isOpenFromQuickTireLookup) {
      if (tire) {
        const _tire = this.helperService.deepCopy(tire);

        this.cartDetails[tireId] = _tire;
      } else {
        delete this.cartDetails[tireId];
      }

      if (callingFrom === 'handleTireSelectQTQ') {
        this.setCartDetailsQTQ(false, 'handleTireSelect');
      } else {
        this.setCartDetails(false, callingFrom);
      }
    } else if (callingFrom === 'handleTireSelectQTQ') {
      if (tire) {
        const _tire = this.helperService.deepCopy(tire);

        this.cartDetails[tireId] = _tire;
      } else {
        delete this.cartDetails[tireId];
      }

      this.setCartDetailsQTQ(false, 'handleTireSelect');
    }
  }

  handleTaxSelect() {
    this.tires.forEach((tire: any) => {
      const taxCalculated = this.calculationService.calculateOrderItemTaxes({
        total: tire?.price || 0,
        taxRates: this.selectedTax?.taxRates,
        roundOffTax: false,
      });
      tire.tireSalesTaxAmt = taxCalculated?.taxAmt;
      if (this.cartDetails[tire?._id]) {
        this.cartDetails[tire?._id].tireSalesTaxAmt = tire.tireSalesTaxAmt;
      }
      if (this.selectedTire[tire?._id]) {
        this.selectedTire[tire?._id].tireSalesTaxAmt = tire.tireSalesTaxAmt;
      }
    });
    if (Object.keys(this.cartDetails)?.length) {
      this.setCartDetails(false);
    }
  }

  handleAddCustomerAndVehicle() {
    this.appOnAddCustomerAndVehicle.emit({ cartDetails: Object.values(this.cartDetails), source: 'Inventory' });
  }

  filterChange(filter: any) {
    this.filter = {
      brand: [],
      categories: [],
      loadIndex: [],
      season: [],
      speedRating: [],
      leadTime: [],
      warehouse: [],
      orderBy: [],
      availability: [],
    };

    const { orderBy, availability } = filter;

    if (availability?.selected?.length) {
      this.filter.availability = availability?.selected.map(({ _id }) => _id);
    }

    if (orderBy?.selected?.length) {
      this.filter.orderBy = orderBy?.selected.map(({ _id }) => _id);
    }

    this.pageNumber = 1;
    this.getTireSizesAndStock();
  }

  setCartDetailsQTQ(isAddedToCart?: boolean, callingFrom?: string) {
    const groupedTires = {};

    this.selectedTireId = {};

    Object.values(this.cartDetails).forEach((tire: any) => {
      if (tire?.warehouse?.warehouseId && !groupedTires[tire.warehouse.warehouseId]) {
        groupedTires[tire.warehouse.warehouseId] = {
          warehouseId: tire.warehouse.warehouseId,
          warehouseName: tire.warehouse.name,
          tires: [],
          total: {
            total: 0,
            cost: 0,
            price: 0,
            totalPrice: 0,
            shippingCost: this.warehouseShippings[tire.warehouse.warehouseId] || 0,
          },
        };
      }

      if (tire?.warehouse?.warehouseId && groupedTires[tire.warehouse.warehouseId]) {
        groupedTires[tire.warehouse.warehouseId].tires.push(tire);
        //groupedTires[tire.warehouse.warehouseId].total.cost += tire.price * tire.count;
        groupedTires[tire.warehouse.warehouseId].total.cost += tire.cost * tire.count;

        const { cost, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

        groupedTires[tire.warehouse.warehouseId].total.total = cost + shippingCost;

        if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
          groupedTires[tire.warehouse.warehouseId].total.price += tire.price * tire.count;

          const { price, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

          groupedTires[tire.warehouse.warehouseId].total.totalPrice = price + shippingCost;
        }
      }
    });

    if (isAddedToCart) {
      this.cartitemList?.forEach((warehouse: any) => {
        if (groupedTires[warehouse?.warehouseId]) {
          warehouse.warehouseId = groupedTires[warehouse?.warehouseId]?.warehouseId;
          warehouse.warehouseName = groupedTires[warehouse?.warehouseId]?.warehouseName;
          warehouse.tires = groupedTires[warehouse?.warehouseId]?.tires;
          warehouse.total = groupedTires[warehouse?.warehouseId]?.total;
        }
      });
    } else {
      this.cartitemList = Object.values(groupedTires);
    }
    //this.cartitemList = Object.values(groupedTires);

    Object.values(this.selectedTire).forEach(({ numericItemId, price, count, warehouse }: any) => {
      if (!this.selectedTireId[numericItemId]) {
        this.selectedTireId[numericItemId] = { count: 0, amount: 0, locations: {} };
      }

      this.selectedTireId[numericItemId].locations[warehouse?.warehouseId] = { warehouseId: warehouse?.warehouseId, count };
      this.selectedTireId[numericItemId].count += count;
      this.selectedTireId[numericItemId].amount += price * count;
    });

    this.setCartSummary(callingFrom);
    this.setItemCount();
  }

  setCartDetails = debounce(async (isAddedToCart?: boolean, callingFrom?: string) => {
    const groupedTires = {};

    this.selectedTireId = {};

    Object.values(this.cartDetails).forEach((tire: any) => {
      if (tire?.warehouse?.warehouseId && !groupedTires[tire.warehouse.warehouseId]) {
        groupedTires[tire.warehouse.warehouseId] = {
          warehouseId: tire.warehouse.warehouseId,
          warehouseName: tire.warehouse.name,
          tires: [],
          total: {
            total: 0,
            cost: 0,
            price: 0,
            totalPrice: 0,
            totalTaxAmount: 0,
            totalFetValue: 0,
            shippingCost: this.warehouseShippings[tire.warehouse.warehouseId] || 0,
          },
        };
      }

      if (tire?.warehouse?.warehouseId && groupedTires[tire.warehouse.warehouseId]) {
        groupedTires[tire.warehouse.warehouseId].tires.push(tire);
        //groupedTires[tire.warehouse.warehouseId].total.cost += tire.price * tire.count;
        groupedTires[tire.warehouse.warehouseId].total.cost += tire.cost * tire.count;

        const { cost, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

        groupedTires[tire.warehouse.warehouseId].total.total = cost + shippingCost;

        if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
          groupedTires[tire.warehouse.warehouseId].total.price += tire.price * tire.count;

          const { price, shippingCost } = groupedTires[tire.warehouse.warehouseId].total;

          groupedTires[tire.warehouse.warehouseId].total.totalPrice = price + shippingCost;

          if (this.isQTQAddOnEnable) {
            groupedTires[tire.warehouse.warehouseId].total.totalTaxAmount += (tire?.tireSalesTaxAmt || 0) * tire.count;

            if (this.isPassThroughTaxEnable) {
              groupedTires[tire.warehouse.warehouseId].total.totalFetValue += (tire?.fetValue || 0) * tire.count;
            }
          }
        }
      }
    });

    if (isAddedToCart) {
      this.cartitemList?.forEach((warehouse: any) => {
        if (groupedTires[warehouse?.warehouseId]) {
          warehouse.warehouseId = groupedTires[warehouse?.warehouseId]?.warehouseId;
          warehouse.warehouseName = groupedTires[warehouse?.warehouseId]?.warehouseName;
          warehouse.tires = groupedTires[warehouse?.warehouseId]?.tires;
          warehouse.total = groupedTires[warehouse?.warehouseId]?.total;
        }
      });
    } else {
      this.cartitemList = Object.values(groupedTires);
    }
    //this.cartitemList = Object.values(groupedTires);

    Object.values(this.selectedTire).forEach(({ numericItemId, price, count, warehouse, tireSalesTaxAmt = 0, fetValue = 0 }: any) => {
      if (!this.selectedTireId[numericItemId]) {
        this.selectedTireId[numericItemId] = { count: 0, amount: 0, locations: {} };
      }

      this.selectedTireId[numericItemId].locations[warehouse?.warehouseId] = { warehouseId: warehouse?.warehouseId, count };
      this.selectedTireId[numericItemId].count += count;
      //this.selectedTireId[numericItemId].amount += price * count;

      if (this.isQTQAddOnEnable) {
        this.selectedTireId[numericItemId].amount += (price + tireSalesTaxAmt) * count;
        if (this.isPassThroughTaxEnable) {
          this.selectedTireId[numericItemId].amount += fetValue * count;
        }
      } else {
        this.selectedTireId[numericItemId].amount += price * count;
      }
    });

    this.setCartSummary(callingFrom);
    this.setItemCount();
  }, 600);

  setGlobalCartAdSummary(callingFrom?: string) {
    this.appOnSetGlobalCart.emit({
      cartitemList: this.cartitemList,
      cartSummary: this.cartSummary,
      selectedTireId: this.selectedTireId,
      cartDetails: this.cartDetails,
      source: 'autoleap',
      callingFrom,
    });
  }

  setItemCount() {
    this.updateSelectedItemCount.emit({ source: 'autoleap', count: this.cartSummary.count });
  }

  setCartSummary(callingFrom?: string) {
    this.cartSummary = {
      total: 0,
      shippingCost: 0,
      grand: 0,
      count: 0,
      totalPrice: 0,
      grandPrice: 0,
      totalTaxAmount: 0,
      totalFetValue: 0,
    };
    this.cartitemList.forEach(({ tires, total }) => {
      this.cartSummary.total += this.calculationService.roundOff(total?.cost);
      this.cartSummary.shippingCost += this.calculationService.roundOff(total?.shippingCost);

      if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
        this.cartSummary.totalPrice += this.calculationService.roundOff(total?.price);

        if (this.isQTQAddOnEnable) {
          this.cartSummary.totalTaxAmount += total?.totalTaxAmount || 0;
          if (this.isPassThroughTaxEnable) {
            this.cartSummary.totalFetValue += total?.totalFetValue || 0;
          }
        }
      }

      if (tires?.length) {
        tires.forEach(({ price, count }) => {
          this.cartSummary.count += count;
        });
      }
    });
    this.cartSummary.grand = this.calculationService.roundOff(this.cartSummary.total + this.cartSummary.shippingCost);
    if (this.isOpenFromQuickTireLookup || this.isOpenFromRO) {
      this.cartSummary.grandPrice = this.calculationService.roundOff(this.cartSummary.totalPrice + this.cartSummary.shippingCost);
    }
    if (this.isQTQAddOnEnable) {
      this.cartSummary.grand += this.calculationService.roundOff(this.cartSummary.totalTaxAmount);
      this.cartSummary.grandPrice += this.calculationService.roundOff(this.cartSummary.totalTaxAmount);
      if (this.isPassThroughTaxEnable) {
        this.cartSummary.grand += this.calculationService.roundOff(this.cartSummary.totalFetValue);
        this.cartSummary.grandPrice += this.calculationService.roundOff(this.cartSummary.totalFetValue);
      }
      this.setGlobalCartAdSummary(callingFrom);
    }
  }

  handleCountChange(tireId: string, count: number, isAddedToCart?: boolean, callingFrom?: string) {
    if (this.selectedTire[tireId]) {
      const totalCount = count + this.selectedTire[tireId].count;

      if (totalCount > 0) {
        this.selectedTire[tireId].count = totalCount;
      }

      if (this.isQTQAddOnEnable) {
        this.selectedTire[tireId].count = Number(count);
      }

      if (this.isOpenFromQuickTireLookup) {
        if (this.cartDetails[tireId]) {
          this.cartDetails[tireId].count = Number(count);
        }

        this.setCartDetails(isAddedToCart, callingFrom);
      }
    }
  }

  handleServiceCreate(services: any[] = []) {
    this.services = [...services];
    this.appHandleSelectTire.emit(this.helperService.deepCopy(this.selectedTire));
  }

  handleClose(isSuccess?: boolean, services: any[] = []) {
    this.dynamicDialogRef.close({ isSuccess, data: { services } });
  }

  handleValidation() {
    let isValid = true;

    Object.keys(this.selectedTire).forEach((tireId) => {
      if (!(this.selectedTire[tireId] && this.selectedTire[tireId].service)) {
        isValid = false;
      }
    });

    return isValid;
  }

  handleSubmit() {
    if (!this.handleValidation()) return;

    const services = [];

    Object.values(this.selectedTire).forEach((data: any) => {
      if (data.service && data.service._id) {
        const serviceIndex = findIndex(services, { _id: data.service._id });

        if (serviceIndex === -1) {
          services.push({ _id: data.service._id, items: [data] });
        } else {
          services[serviceIndex].items.push(data);
        }
      } else if (data.service && data.service.serviceTempId) {
        const serviceIndex = findIndex(services, { serviceTempId: data.service.serviceTempId });

        if (serviceIndex === -1) {
          services.push({ ...data.service, items: [data] });
        } else {
          services[serviceIndex].items.push(data);
        }
      }
    });

    this.handleClose(true, services);
  }

  handleViewDetails(tire: any, viewDetails: boolean) {
    tire.viewDetails = viewDetails;
  }

  handleAlTireValidation(obj: any = null) {
    this.appHandleAlTireValidation.emit(obj);
  }

  removeCartItems() {
    this.tires = [];
    this.cartDetails = {};
    this.cartSummary = {
      total: 0,
      shippingCost: 0,
      grand: 0,
      count: 0,
      totalPrice: 0,
      grandPrice: 0,
      totalTaxAmount: 0,
      totalFetValue: 0,
    };
    this.shippingLoader = {};
    this.cartitemList = [];
    this.selectedTireId = {};
    this.warehouseShippings = {};
    this.isCartVisible = false;
    this.setItemCount();
  }

  onScroll = debounce((event: any) => {
    if (this.isLoading) return;

    const element = event.target;

    if (element.scrollHeight - element.scrollTop - element.clientHeight < 10) {
      if (this.tires?.length !== this.totalRecords) {
        let pageNumber = Math.floor(this.tires?.length / config.pageSize) + 1;
        this.getTireSizesAndStock(false, pageNumber);
      }
    }
  }, 100);
}
